import { render, staticRenderFns } from "./xkfl.vue?vue&type=template&id=96e22376&"
import script from "./xkfl.vue?vue&type=script&lang=js&"
export * from "./xkfl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports